import { Box, Button, Image, Text } from "@chakra-ui/react";
import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

// Achievement card
const Card = ({ direction, achievement, isLargerThan1120 }) => {
  return (
    <Box
      w="full"
      h="full"
      minH="50vh"
      display="flex"
      alignItems="center"
      justifyContent={isLargerThan1120 ? "flex-start" : "center"}
      gap={12}
      flexDir={direction}
      mb={isLargerThan1120 ? 4 : 8}
      px={{ base: "0", sm: "1rem", xl: "0" }}
    >
      {/* info */}
      <Box
        w={isLargerThan1120 ? "50%" : "100%"}
        // px="2rem"
        display="flex"
        flexDir="column"
        gap={{ base: 4, md: 8 }}
        alignItems="flex-start"
      >
        {/* title */}
        <Text color="#fff" lineHeight="1.3" fontSize="1.25rem" fontWeight="500">
          {achievement.title}
        </Text>
        <Text
          color="#CBD5E1"
          lineHeight="1.6"
          fontSize="1.1rem"
          fontWeight="400"
        >
          {achievement.desc}
        </Text>
        <Button
          w="auto"
          variant="unstyled"
          bg="rgb(229 231 235)"
          color="rgb(30 41 59)"
          p="0.375rem 1.5rem"
          fontWeight="600"
          borderRadius="9999px"
          margin={isLargerThan1120 ? "0" : "auto"}
          onClick={() => {
            const url = achievement.preview_link;
            window.open(url, "_blank");
          }}
        >
          Check Out
        </Button>
      </Box>
      {/* image */}
      <Box w={isLargerThan1120 ? "50%" : "100%"}>
        <Carousel
          autoPlay
          interval={3000}
          infiniteLoop
          showStatus={false}
          swipeable={true}
          emulateTouch={true}
          showArrows={false}
          showThumbs={false}
          // onClickItem={(index) => {
          //   const url = achievement.imgs_preview_link[index];
          //   window.open(url, "_blank");
          // }}
        >
          {achievement.imgs_path.map((img) => {
            return (
              <Image
                zIndex={100}
                key={img}
                w="full"
                h="300px"
                objectFit="cover"
                borderRadius="1.5rem"
                overflow="hidden"
                src={img}
                cursor="pointer"
              />
            );
          })}
        </Carousel>
      </Box>
    </Box>
  );
};

export default Card;
